import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuroraBackground } from "@/components/AuroraBackground";
import { Footer } from "@/components/Footer";
import { logWarn } from "@/lib/log";

const Box = ({ children }) => (
  <div className="min-h-screen flex flex-col"><AuroraBackground />
    <main className="flex-1 flex items-center justify-center px-4"><div className="hud-card hud-corners p-8 max-w-md w-full text-center">{children}</div></main>
    <Footer />
  </div>
);

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    const sid = params.get("session_id");
    let n = 0, timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); refreshUser(); return; }
        if (data.status === "expired") { setStatus("failed"); return; }
      } catch (e) { logWarn("Operazione non riuscita", e); }
      if (++n < 15) timer = setTimeout(poll, 2000); else setStatus("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, refreshUser]);

  return (
    <Box>
      <div data-testid="payment-status">
        {status === "pending" && <><Loader2 className="mx-auto animate-spin text-cyan-300" size={40} /><p className="mt-4 text-slate-300">Verifica del pagamento in corso…</p></>}
        {status === "paid" && <><CheckCircle2 className="mx-auto text-emerald-400" size={44} /><h1 className="font-heading text-2xl text-white mt-4">Abbonamento attivo!</h1><p className="text-slate-400 mt-2">Grazie, il tuo piano Pro è stato esteso.</p></>}
        {(status === "failed" || status === "timeout") && <><XCircle className="mx-auto text-rose-400" size={44} /><p className="mt-4 text-slate-300">Non siamo riusciti a confermare il pagamento. Se hai pagato, contatta il supporto.</p></>}
      </div>
      <Link to="/app" data-testid="btn-back-to-app" className="btn-aurora inline-flex mt-6 rounded-full px-6 py-2.5 text-sm uppercase">Torna ad Aurora</Link>
    </Box>
  );
}

export function PaymentCancel() {
  return (
    <Box>
      <XCircle className="mx-auto text-amber-400" size={44} />
      <h1 className="font-heading text-2xl text-white mt-4">Pagamento annullato</h1>
      <p className="text-slate-400 mt-2">Nessun addebito effettuato.</p>
      <Link to="/app" data-testid="btn-back-to-app-cancel" className="btn-aurora inline-flex mt-6 rounded-full px-6 py-2.5 text-sm uppercase">Torna ad Aurora</Link>
    </Box>
  );
}
